module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-8-128.f9748a8d388ad2b3.png"+" 128w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-8-128.f9748a8d388ad2b3.png",width: 128,height: 85}],
        src: "https://static.sniffspot.com/packs/img/bp-8-128.f9748a8d388ad2b3.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-8-128.f9748a8d388ad2b3.png"},
        
        width: 128,
        height: 85
      }